import React, {Component, Fragment, Suspense} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Modals from './index';
import {PORTAL_NAME} from '../../../config.json';
import {logError, ModalError} from '../ErrorBounds';
import {ErrorBoundary} from 'react-error-boundary';
import {_removeAllModals} from '../../../shared/store';

const AdvisorModals = React.lazy(() => import('../../../advisor/modals'));
const InvestorModals = React.lazy(() => import('../../../investor/modals'));
const OpsModals = React.lazy(() => import('../../../ops/modals'));

class ModalManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalComponents: {...Modals},
    };
  }

  render() {
    const {modalComponents} = this.state;

    return (
      <ErrorBoundary
        FallbackComponent={props => (
          <ModalError
            {...this.props}
            {...props}
          />
        )}
        onReset={() => {
          this.props.removeAllModals();
        }}
        onError={logError}>
        <Fragment>
          {
            this.props.modals && this.props.modals.map(modal => {
              const ModalType = modalComponents[modal.type] || modalComponents[modal.componentName];
              if (!ModalType) {
                if (PORTAL_NAME === 'advisor') {
                  return <Suspense key={'s' + modal.id} fallback={<div/>}>
                    <AdvisorModals modalName={modal.type || modal.componentName} content={modal}/>
                  </Suspense>;
                }
                if (PORTAL_NAME === 'investor') {
                  return <Suspense key={'s' + modal.id} fallback={<div/>}>
                    <InvestorModals modalName={modal.type || modal.componentName} content={modal}/>
                  </Suspense>;
                }
                if (PORTAL_NAME === 'ops') {
                  return <Suspense key={'s' + modal.id} fallback={<div/>}>
                    <OpsModals modalName={modal.type || modal.componentName} content={modal}/>
                  </Suspense>;
                }
              }
              return <ModalType key={modal.id} content={modal}/>;
            })
          }
        </Fragment>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = state => ({
  modals: state.modals,
});

const mapDispatchToProps = dispatch => ({
  removeAllModals: () => dispatch(_removeAllModals()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalManager);

ModalManager.propTypes = {
  modals: PropTypes.array.isRequired,
  removeAllModals: PropTypes.func,
};
